module.exports = __webpack_public_path__ + "img/bg6.7e8c0910.png";